import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FilterDefinition, SelectedFilter } from '../../../../../models/Filters';

@Component({
  selector: 'app-filter-map-autocomplete',
  templateUrl: './filter-map-autocomplete.component.html',
  styleUrls: ['./filter-map-autocomplete.component.css']
})
export class FilterMapAutocompleteComponent implements OnInit {
  @Input() form: FormGroup
  @Input() filter: FilterDefinition;
  @Input() selected: string;
  @Output() onOptionSelected = new EventEmitter<SelectedFilter>();
  @Output() onOptionDeleted = new EventEmitter<SelectedFilter>();

  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  constructor() {
    
  }

  ngOnInit() {
    this.options = this.filter.values || [];
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
  }

  onDelete() : void {
    this.selected = '';
    const filter: SelectedFilter = {
      key: this.filter.key,
      value: this.selected,
      module: this.filter.module || ''
    };
    this.onOptionDeleted.emit(filter);
  }

  onSelect(option: string){
    this.selected = option;
    const filter: SelectedFilter = {
      key: this.filter.key,
      value: option,
      module: this.filter.module || ''
    };
    this.onOptionSelected.emit(filter);
  }

  private _filter(value: string): string[] {
    const filterValue = (value ?? "").toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  verifyOnBlur(){
    const option = this.options.find(option => option.toLowerCase() === (this.selected ?? "").toLowerCase());
    if(option == null || this.selected === ''){
      this.selected = '';
      const filter: SelectedFilter = {
        key: this.filter.key,
        value: this.selected,
        module: this.filter.module || ''
      };
      this.onOptionDeleted.emit(filter);
    }else{
      this.selected = option;
      const filter: SelectedFilter = {
        key: this.filter.key,
        value: option,
        module: this.filter.module || ''
      };
      this.onOptionSelected.emit(filter);
    }
  }
}
